/** Live "X of N required answered" for one building, as returned by each autosave. */
export interface BuildingCompletion {
  requiredTotal: number
  requiredAnswered: number
  isComplete: boolean
}

export const completionText = (completion?: BuildingCompletion): string =>
  completion != null ? `${completion.requiredAnswered} of ${completion.requiredTotal} Complete` : ''
